import React from "react";
import { Col, Row, ProgressBar } from "react-bootstrap";
import {translate} from 'react-i18next';
@translate('translations')
class InProgress extends React.Component {
  render() {
    const {t} = this.props
    return (
      <Row style={{ height: "90vh", padding: "35vh 25% 0 25%" }}>
        <Col xs={12} md={12}>
          <h4>{t('common.loading')}</h4>
          <ProgressBar
            striped
            bsStyle="warning"
            style={{ width: "100%", height: "35px" }}
            active
            now={100}
          />
        </Col>
      </Row>
    );
  }
}

export default InProgress;
